export const ADMIN_NOTIFICATION_EVENT = "admin-notification";

export type AdminNotificationType = "success" | "error" | "info" | "warning";

export type AdminNotificationEventDetail = {
  type: AdminNotificationType;
  message: string;
  description?: string;
  duration?: number;
};

export function dispatchAdminNotification(
  detail: AdminNotificationEventDetail,
) {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent<AdminNotificationEventDetail>(ADMIN_NOTIFICATION_EVENT, {
      detail,
    }),
  );
}
